<template>
  <div :class="['take-note-input', 'input-container', getFocusClass('takeNote')]">
    <!-- <div class="fsz-28 fsz-md-32">Take Note Of</div> -->
    <v-select
    placeholder="Take Note Of"
      hide-details
      :items="options"
      :value="value"
      @change="$emit('change', { field: 'takeNote', newValue: $event })"
    ></v-select>
  </div>
</template>

<script>
  export default {
    props: {
      options: Array,
      value: String,
      getFocusClass: Function,
    },
  };
</script>
